<template>
    <div class="feedbackbar"
        :class="correctnessClass">
        <svg v-if="correctness === 1" class="feedbackbar__icon" width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.04.677L6.547 9.17 2.664 5.287a1.173 1.173 0 00-1.658 1.658l4.712 4.712a1.17 1.17 0 001.658 0l9.322-9.322A1.173 1.173 0 0015.04.677z" fill="#fff"/></svg>
        <svg v-if="correctness === 0" class="feedbackbar__icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.33 10.942L9.25 6.868l4.08-4.074a1.441 1.441 0 10-2.037-2.04L7.208 4.833 3.127.755a1.441 1.441 0 10-2.037 2.04l4.079 4.073-4.08 4.074a1.44 1.44 0 102.038 2.039L7.21 8.904l4.083 4.077c.28.28.65.42 1.019.42a1.44 1.44 0 001.018-2.46z" fill="#ED3827"/></svg>
        <svg v-if="correctness === -1" class="feedbackbar__icon" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.33 10.942L9.25 6.868l4.08-4.074a1.441 1.441 0 10-2.037-2.04L7.208 4.833 3.127.755a1.441 1.441 0 10-2.037 2.04l4.079 4.073-4.08 4.074a1.44 1.44 0 102.038 2.039L7.21 8.904l4.083 4.077c.28.28.65.42 1.019.42a1.44 1.44 0 001.018-2.46z" fill="#333" fill-opacity=".8"/></svg>
        <span class="feedbackbar__text">{{ feedbackText }}</span>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            correctness: { type: Number, default: null },
        },

        computed: {
            correctnessClass(){
                if(this.correctness === 1){
                    return 'feedbackbar--correct';
                }
                else if(this.correctness === 0){
                    return 'feedbackbar--incorrect';
                }
                else if(this.correctness === -1){
                    return 'feedbackbar--skipped';
                }
            },

            feedbackText(){
                if(this.correctness === 1){
                    return 'DOĞRU';
                }
                else if(this.correctness === 0){
                    return 'YANLIŞ';
                }
                else if(this.correctness === -1){
                    return 'GEÇİLDİ';
                }
                return 'LOREM IPSUM';
            }
        }
    };
</script>

<style scoped src="@/css/components/feedbackbar.css"></style>